import { useState } from "react"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { api } from "../api"
import { messageFor } from "../shared"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Field, FieldError, FieldLabel } from "@/components/ui/field"
import { Textarea } from "@/components/ui/textarea"

/** Sends an already-approved split back to its owner's inbox; every approval on it is cleared. */
export function ReturnDialog({ allocationId, employee, onClose }: { allocationId: number; employee: string; onClose: () => void }) {
  const client = useQueryClient()
  const [reason, setReason] = useState("")
  const send = useMutation({
    mutationFn: () => api<void>(`/allocations/${allocationId}/return`, { method: "POST", body: JSON.stringify({ reason: reason.trim() }) }),
    onSuccess: async () => {
      await Promise.all(["allocation", "allocations", "approvals", "returnable", "process-tasks", "process-status"].map((key) => client.invalidateQueries({ queryKey: [key] })))
      onClose()
    },
  })
  return (
    <Dialog open onOpenChange={(open) => { if (!open) onClose() }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>برگشت نسبت کاری {employee} برای اصلاح</DialogTitle>
          <DialogDescription>تأییدهای این نسبت کاری برداشته می‌شود و برای اصلاح به کارتابل {employee} برمی‌گردد. پس از ارسال دوباره، از اول مسیر تأیید را طی می‌کند.</DialogDescription>
        </DialogHeader>
        <form onSubmit={(event) => { event.preventDefault(); send.mutate() }}>
          <Field>
            <FieldLabel htmlFor="return-reason">علت برگشت</FieldLabel>
            <Textarea id="return-reason" value={reason} onChange={(event) => setReason(event.target.value)} autoFocus required />
          </Field>
          {send.error && <FieldError role="alert" className="mt-2">{messageFor(send.error)}</FieldError>}
          <DialogFooter className="mt-4">
            <Button type="submit" variant="destructive" disabled={!reason.trim() || send.isPending}>{send.isPending ? "در حال ارسال…" : "برگشت به کاربر"}</Button>
            <Button type="button" variant="ghost" onClick={onClose}>انصراف</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
